export class Plano {
    ativo:boolean;
    id:number;
    descricao:string;
    titulo:string;
    marcaId: number;
    modeloId: number;
    categoriaId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/shared/plano.model.ts
 **/